// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDBE5DO2IW4J7TSBb7x1J1uy23UM9VL6Zw",
    authDomain: "grupo-cultural.firebaseapp.com",
    databaseURL: "https://grupo-cultural.firebaseio.com",
    projectId: "grupo-cultural",
    storageBucket: "grupo-cultural.appspot.com",
    messagingSenderId: "147595119680",
    appId: "1:147595119680:web:7ddd84437befdd0974a3a5",
    measurementId: "G-DGEXDB40GX"



  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
